<div class="global-overlay-page">
  <div style="display: flex; justify-content: center;padding:20px;">

    <div style="width:100%;">

      <div class="menu" style="display: flex; justify-content: space-between; margin-bottom: 20px;">
        <h2>{{email}}</h2>

        <div class="toolbar">
          <a (click)="updateEmail()">Change email</a>
          <a (click)="deleteUser()" style="background-color:red;">Delete User</a>
        </div>
      </div>

      <mat-table #table [dataSource]="dataSource" matSort>

        <ng-container matColumnDef="codes">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Code</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.codes}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="description">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Description</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.description}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="content">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Content</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.content_name}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="step">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Step</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.step}}</mat-cell>
        </ng-container>


        <ng-container matColumnDef="total_steps">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Total steps</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.total_steps}}</mat-cell>
        </ng-container>


        <ng-container matColumnDef="time_spent">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Time spent</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.time_spent}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
          <mat-cell *matCellDef="let element">
            @if (element.complete) {
              <div class="status" style="color:green;">Completed</div>
            }
            @if (element.complete === false) {
              <div class="status" style="color:red;">Incomplete</div>
            }
            @if (element.notStarted) {
              <div class="status" style="color:blue;">Not started</div>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Actions</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div class="toolbar" style="white-space: nowrap; flex-wrap: nowrap;">
              <a (click)="reset(element.hcontent_id)" [style.opacity]="element.complete ? 0.5 : 1"
              [style.cursor]="'pointer'">Reset Progress</a>
              <a (click)="!element.complete && complete(element.hcontent_id)"
                [attr.disabled]="element.complete ? true : null" [style.opacity]="element.complete ? 0.5 : 1"
              [style.cursor]="element.complete ? 'not-allowed' : 'pointer'">Complete</a>
            </div>
          </mat-cell>
        </ng-container>


        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

    </div>

  </div>
</div>